<script>
import { products } from '@/constants/launchpad';
import Title from '@/components/Launchpad/Title';
import LaunchpadCard from '@/components/Launchpad/LaunchpadCard';

export default {
  name: 'UpcomingProducts',
  components: {
    Title,
    LaunchpadCard,
  },
  data() {
    return {
      activeProducts: [],
    };
  },
  created() {
    this.activeProducts = Object.entries(products).filter((i) => !i[1].isFinished);
  },
  methods: {
    getIconSrc(icon) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`../../assets/img/${this.$chain.getName()}/launchpad/${icon}.jpg`);
    },
  },
};
</script>

<template>
  <div v-if="activeProducts.length" class="mt-10">
    <Title>{{ $t('upcoming.current') }}</Title>
    <v-row justify="center">
      <LaunchpadCard
        v-for="(product, index) in activeProducts.slice(0, 2)"
        :product="product[1]"
        :link="product[0]"
        :key="index"
      />
    </v-row>
    <!-- <v-row justify="center">
      <LaunchpadCard
        v-for="(product, index) in activeProducts.slice(2, 5)"
        :product="product[1]"
        :link="product[0]"
        :key="index"
      />
    </v-row> -->
    <v-row justify="center">
      <LaunchpadCard
        v-for="(product, index) in activeProducts.slice(2)"
        :product="product[1]"
        :link="product[0]"
        :key="index"
      />
    </v-row>

  </div>
</template>

<style lang="scss">
</style>
